import { render } from "./EventData.vue?vue&type=template&id=53faf940"
import script from "./EventData.vue?vue&type=script&lang=js"
export * from "./EventData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__